var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupicon = function SvgGroupicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.638 4.364a3.273 3.273 0 1 0 0 6.546 3.273 3.273 0 0 0 0-6.546Zm12.004 3.272a3.273 3.273 0 1 1-6.547 0 3.273 3.273 0 0 1 6.547 0Zm4.245 10.419-1.572-3.153a3.274 3.274 0 0 0-2.924-1.81h-4.365c.2.259.375.537.524.828l1.582 3.164c.391.797.443 1.718.142 2.553h5.641a1.091 1.091 0 0 0 .972-1.582ZM10.65 13.09c1.243-.002 2.38.7 2.935 1.811l1.572 3.153a1.09 1.09 0 0 1-.971 1.582H1.09a1.091 1.091 0 0 1-.971-1.582l1.571-3.153a3.274 3.274 0 0 1 2.936-1.81h6.023Z",
    clipRule: "evenodd"
  })));
};
export default SvgGroupicon;